import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box, Divider, Typography } from '@material-ui/core'
import features from 'common/college-features'

import dashboardTeaser from './dashboard-teaser.png'
import messagingTeaser from './messaging-teaser.png'
import premiumPresenceTeaser from './premium-presence-teaser.png'

const useStyles = makeStyles(() => ({
  title: {
    fontSize: 20,
    fontWeight: 500,
  },
  teaserImage: {
    width: 232,
  },
  actions: {
    justifyContent: 'space-between',
  },
}))

const RequestFeatureAccessModal = ({ feature, show, onHide }) => {
  const styles = useStyles()
  const getTitle = () => {
    switch (feature) {
      case features.SUPPORTS_CONTENT_MANAGEMENT:
        return 'Upgrade to Premium Presence'
      case features.SUPPORTS_STUDENT_OUTREACH:
        return 'Upgrade to Outreach Messaging'
      default:
        return ''
    }
  }
  const getSubTitle = () => {
    switch (feature) {
      case features.SUPPORTS_CONTENT_MANAGEMENT:
        return 'Uh oh! You only have a basic profile. Upgrade to Premium Presence to create content.'
      case features.SUPPORTS_STUDENT_OUTREACH:
        return `Uh oh! You don't have Outreach Messaging on Scoir. Upgrade to message interested students and parents.`
      default:
        return ''
    }
  }
  const renderContent = () => {
    switch (feature) {
      case features.SUPPORTS_CONTENT_MANAGEMENT:
        return (
          <>
            <Typography>
              <strong>
                Students are nearly 2x more likely to engage with your college when you upgrade. Premium Presence
                includes:
              </strong>
            </Typography>
            <ul>
              <li>Personalized content</li>
              <li>Dynamic multimedia cards</li>
              <li>Improved search relevance</li>
              <li>Event promotion</li>
              <li>Unlimited website links</li>
              <li>& much more!</li>
            </ul>
          </>
        )
      case features.SUPPORTS_STUDENT_OUTREACH:
        return (
          <>
            <Typography>
              <strong>
                Students are 3x more likely to submit an application when you message them. Outreach Messaging includes:
              </strong>
            </Typography>
            <ul>
              <li>Unlimited messages</li>
              <li>Advanced segmentation</li>
              <li>Automated, trigger-based sends</li>
              <li>Scheduling</li>
              <li>Performance metrics</li>
            </ul>
          </>
        )
      default:
        return ''
    }
  }
  const getUrl = () => {
    switch (feature) {
      case features.SUPPORTS_CONTENT_MANAGEMENT:
        return 'https://www.scoir.com/colleges/product/premium-presence/upsell'
      case features.SUPPORTS_STUDENT_OUTREACH:
        return 'https://www.scoir.com/colleges/products/outreach-messaging/upgrade'
      default:
        return ''
    }
  }
  const getImage = () => {
    switch (feature) {
      case features.SUPPORTS_CONTENT_MANAGEMENT:
        return premiumPresenceTeaser
      case features.SUPPORTS_STUDENT_OUTREACH:
        return messagingTeaser
      default:
        return dashboardTeaser
    }
  }
  const getImageAltText = () => {
    switch (feature) {
      case features.SUPPORTS_CONTENT_MANAGEMENT:
        return 'preview of premium presence'
      case features.SUPPORTS_STUDENT_OUTREACH:
        return 'preview of outreach messaging'
      default:
        return 'preview of dashboard analytics'
    }
  }

  return (
    <Dialog
      open={show}
      onClose={onHide}
    >
      <DialogTitle>
        <Typography className={styles.title}>{getTitle()}</Typography>
      </DialogTitle>
      <Divider />
      <DialogContent>
        <Box
          display={'flex'}
          width={'100%'}
          height={233}
          borderRadius={6}
          alignItems="center"
          justifyContent="center"
          bgcolor="#BBE4EF"
        >
          <img
            className={styles.teaserImage}
            src={getImage()}
            alt={getImageAltText()}
          />
        </Box>
      </DialogContent>
      <DialogTitle>{getSubTitle()}</DialogTitle>
      <DialogContent>
        {renderContent()}
        <DialogActions className={styles.actions}>
          <Button
            variant="text"
            onClick={onHide}
            color={'primary'}
          >
            Cancel
          </Button>
          <Button
            href={getUrl()}
            target="_blank"
            variant="contained"
            color="primary"
          >
            Learn More
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  )
}

RequestFeatureAccessModal.propTypes = {
  feature: PropTypes.string.isRequired,
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
}

export default RequestFeatureAccessModal
